import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations, actions, getters } from './mutations'

Vue.use(Vuex)

export const store = new Vuex.Store({
	state,
	mutations,
	getters,
	actions,
})
